const focusIntent = { shouldFocusDetailTabs: false };

export const requestDetailTabsFocus = () => {
    focusIntent.shouldFocusDetailTabs = true;
};

export const consumeDetailTabsFocus = () => {
    if (focusIntent.shouldFocusDetailTabs) {
        focusIntent.shouldFocusDetailTabs = false;
        return true;
    }
    return false;
};
